module.exports = __webpack_public_path__ + "static/media/social-icon-linkedin-aqua.f2859bb9.svg";